import { render, staticRenderFns } from "./UserLockerMigration.vue?vue&type=template&id=298bae34&"
import script from "./UserLockerMigration.vue?vue&type=script&lang=ts&"
export * from "./UserLockerMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports